import { Panel } from "searchkit";

export class MyPanel extends Panel {}
MyPanel.defaultProps = {
  disabled: false,
  collapsable: true,
  defaultCollapsed: true,
  mod: "sk-panel",
};
